import React, { useState } from "react";
import styles from "./Row.module.sass";
import Checkbox from "../../../../../components/Checkbox";
import Icon from "../../../../../components/Icon";
import Actions from "../../../../../components/Actions";
import Modal from "../../../../../components/Modal";
import Schedule from "../../../../../components/Schedule";
import Control from "./Control";
import ModalTutor from "../../../../../components/ModalTutor";

const Row = ({ item, value, onChange, onEdit, onDelete }) => {
    const [startDate, setStartDate] = useState(new Date());
    const [startTime, setStartTime] = useState(new Date());

    const [visibleModalProduct, setVisibleModalProduct] = useState(false);
    const [visibleModalSchedule, setVisibleModalSchedule] = useState(false);

    const actions = [

        {
            title: "Modifier le tuteur",
            icon: "edit",
            action: () => onEdit ? onEdit(item) : console.log("Edit tutor"),
        },
        {
            title: "Supprimer le tuteur",
            icon: "trash",
            action: () => onDelete ? onDelete(item.id) : console.log("Delete tutor"),
        },
    ];

    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <Checkbox
                        className={styles.checkbox}
                        value={value}
                        onChange={(e) => onChange(e.target.checked)}
                    />
                </div>
                <div className={styles.col}>
                    <div
                        className={styles.item}
                        onClick={() => onEdit ? onEdit(item) : null}
                    >
                        <div className={styles.avatar}>
                            <img src="/images/content/tutor_logo.png" alt="Tutor" />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.product}>{item.first_name} {item.last_name}</div>
                            <div className={styles.link}>{item.job_title || 'Poste non spécifié'}</div>
                            <div className={styles.date}>
                                <Icon name="mail" size="20" /> {item.email || 'Email non spécifié'}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.link}>
                        {item.email}
                    </div>
                </div>
                <div className={styles.col}>
                    <div className={styles.link}>
                        {item.phone && (
                            <div className={styles.phone}>
                                +{item.phone}
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.col}>
                    {item.date}
                    <Control
                        className={styles.control}
                        item={item}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                </div>
            </div>
            <Modal
                visible={visibleModalSchedule}
                onClose={() => setVisibleModalSchedule(false)}
            >
                <Schedule
                    startDate={startDate}
                    setStartDate={setStartDate}
                    startTime={startTime}
                    setStartTime={setStartTime}
                />
            </Modal>
        </>
    );
};

export default Row;
